<section>
    <div class="container-xl" style="margin: auto;padding: 0px;margin-top: calc( ( 50vh - 220px ) / 2 );">
        <div class="row" style="margin: 0px;">
            <div class="col-1 col-md-3 col-lg-6 col-xxl-8" style="padding: 0px;"></div>
            <div class="col" style="padding: 0px;">
                <div style="max-width: 23rem;margin-right: 0px;margin-top: 0px;">
                    <h5 class="text-start text-primary">&nbsp;</h5>
                    <div class="text-light text-bg-primary border rounded border-2 border-success" style="max-width: 23rem;">
                        @if (registrationResult()) {
                            <div class="row align-items-center mx-3 mt-3">
                            <div class="col"><label class="col-form-label text-light" style="padding: 0px;">Registrazione completata!</label><br>
                                <label class="pt-2">Per attivare l'account, segui le istruzioni nel messaggio email di conferma che riceverai a breve.</label></div>
                            </div>
                            <div class="row align-items-center text-center p-2">
                                <div class="col">
                                    <p><a type="button" [style]="sendingMailSuspended() ? 'pointer-events: none' : ''" (click)="sendNewEmail()" class="text-decoration-none position-relative z-1" [class]="sendingMailSuspended() ? 'text-info' : 'text-success'">invia nuovamente la mail</a></p>
                                </div>
                            </div>
                        }
                        @if(!registrationResult()) {
                            <div class="row align-items-center m-3">
                            <div class="col"><label class="col-form-label text-danger" style="padding: 0px;">Si è verificato un problema!</label><br>
                                <label class="pt-2">Ci dispiace, la tua registrazione non è andata a buon fine... riprova più tardi oppure contatta il servizio di assistenza.</label></div>
                            </div>
                        }
                    </div>
                    <h4 class="text-end mb-0 position-relative z-1" style="padding: 15px 35px 0px 0px;"><a routerLink="/login" class="text-decoration-none" routerLinkActive="active" ariaCurrentWhenActive="page">login</a></h4>
                </div>
            </div>
        </div>
    </div>
</section>

